(function () {
  'use strict';

  var timers = document.querySelectorAll('[data-countdown]');
  if (!timers.length) return;

  timers.forEach(function (timer) {
    var target = timer.getAttribute('data-target');
    if (!target) return;

    var targetDate = new Date(target).getTime();
    if (isNaN(targetDate)) return;

    var daysEl  = timer.querySelector('[data-countdown-days]');
    var hoursEl = timer.querySelector('[data-countdown-hours]');
    var minsEl  = timer.querySelector('[data-countdown-mins]');
    var secsEl  = timer.querySelector('[data-countdown-secs]');
    var expiredEl = timer.parentElement
      ? timer.parentElement.querySelector('[data-countdown-expired]')
      : null;

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function update() {
      var now = Date.now();
      var diff = targetDate - now;

      if (diff <= 0) {
        /* Timer expired */
        if (daysEl)  daysEl.textContent  = '00';
        if (hoursEl) hoursEl.textContent = '00';
        if (minsEl)  minsEl.textContent  = '00';
        if (secsEl)  secsEl.textContent  = '00';

        if (expiredEl) {
          expiredEl.style.display = '';
          timer.style.display = 'none';
        }
        return false;
      }

      var days  = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins  = Math.floor((diff % 3600000) / 60000);
      var secs  = Math.floor((diff % 60000) / 1000);

      if (daysEl)  daysEl.textContent  = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl)  minsEl.textContent  = pad(mins);
      if (secsEl)  secsEl.textContent  = pad(secs);

      return true;
    }

    /* Initial render */
    if (update()) {
      /* Tick every second */
      var interval = setInterval(function () {
        if (!update()) clearInterval(interval);
      }, 1000);
    }
  });
})();
